import NoticePopup from '@/components/comunication/modals/notice-popup';

export default {
  name       : 'NoticeEditPreviewContent',
  components : {
    NoticePopup
  },
  props: {
    isModal: {
      type    : Boolean,
      default : false
    },
    designConfigs: {
      type    : Object,
      default : () => ({})
    },
    configurations: {
      type    : Object,
      default : () => ({})
    },
    noticeMainValue: {
      type    : Object,
      default : () => ({})
    },
    isVisible: {
      type    : Boolean,
      default : false
    }
  },

  data: function() {
    return {
      isOpen        : false,
      currentNotice : null,
      tabsKey       : 0,
      tabs          : [
        { title: this.$t('noticeConfigs.previewDesktopTitle') },
        { title: this.$t('noticeConfigs.previewMobileTitle') }
      ]
    };
  },

  watch: {
    isVisible: function(newValue) {
      if (newValue && !this.isModal) {
        this.tabsKey += 1;
      }
    }
  },

  mounted: function() {
    if (this.isModal) {
      this.$nuxt.$on('openHighlightNoticeModal', this.open);
    }
  },

  beforeDestroy: function() {
    if (this.isModal) {
      this.$nuxt.$off('openHighlightNoticeModal');
    }
  },

  computed: {
    noticeConfigs: function() {
      if (this.isModal && this.currentNotice) {
        return this.currentNotice;
      }

      return {
        ...this.configurations,
        ...this.designConfigs,
        ...this.noticeMainValue
      };
    }
  },

  methods: {
    async markAsRead() {
      if (!this.currentNotice || this.currentNotice.isReaded) {
        return;
      }

      const payload = {
        action   : 'include',
        notices  : [this.currentNotice.id],
        isReaded : true
      };

      try {
        await this.$services.notices().markAsReadNotice({
          courseId: this.$route?.params?.courseId,
          payload
        });

        this.currentNotice.isReaded = true;
      } catch (error) {
        this.$toast.error(error.message);
      }
    },
    open: function(payload) {
      if (!payload || !payload.notice) {
        this.$nuxt.$emit('highlightNoticeActionTaken');
        return;
      }
      this.currentNotice = payload.notice;
      this.isOpen = true;
    },

    handleAction: async function() {
      await this.markAsRead();
      if (!this.currentNotice?.isBlockingAccess) {
        this.close();
      }
    },
    close: function() {
      this.isOpen = false;
      this.currentNotice = null;
      this.$nuxt.$emit('highlightNoticeActionTaken');
    }
  }
};